import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
    return (
        <div data-testid="privacy-page" className="bg-[#0A0A0E] text-zinc-100 min-h-screen">
            <Navbar />
            <main className="pt-28 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-cyan-300 mb-6">
                    <ArrowLeft size={14} /> Back
                </Link>
                <span className="section-tag">Legal</span>
                <h1 className="font-display text-4xl sm:text-5xl text-white mt-5 tracking-tighter">Privacy Policy</h1>
                <p className="text-xs font-mono-accent text-zinc-500 mt-3 uppercase tracking-[0.18em]">
                    Last updated · December 2025
                </p>

                <div className="prose prose-invert max-w-none mt-10 space-y-6 text-zinc-300 text-base leading-relaxed">
                    <p>
                        WE DELVR LOGISTICS PTY LTD (&quot;we&quot;, &quot;us&quot;) is committed to protecting your privacy
                        and handling personal information in accordance with the Australian
                        Privacy Act 1988 and the Australian Privacy Principles.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">1. Information we collect</h2>
                    <p>
                        When you submit a form on this site (early access, demo request, quote
                        request or contact), we collect your name, email, optional company,
                        role, phone, freight context and any message you provide. We log
                        technical metadata such as timestamp and submission source.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">2. How we use it</h2>
                    <p>
                        We use this information solely to respond to your enquiry, communicate
                        about WE DELVR LOGISTICS products and services, and improve our offering. We do
                        not sell your personal information to third parties.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">3. Data storage</h2>
                    <p>
                        Submissions are stored in encrypted databases hosted on infrastructure
                        located primarily in Australia and supporting regions. Access is
                        limited to authorised WE DELVR LOGISTICS personnel.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">4. Your rights</h2>
                    <p>
                        You may request access to, correction of, or deletion of your personal
                        information at any time by emailing privacy@wedelvrlogistics.com.au. We will
                        respond within 30 days.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">5. Cookies & analytics</h2>
                    <p>
                        We use minimal cookies and product analytics to understand site
                        performance. No third-party advertising cookies are deployed.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">6. Contact</h2>
                    <p>
                        Privacy enquiries: <a className="text-cyan-300" href="mailto:privacy@wedelvrlogistics.com.au">privacy@wedelvrlogistics.com.au</a>
                    </p>

                    <p className="text-xs font-mono-accent text-zinc-500 mt-10 uppercase tracking-[0.18em]">
                        This is a template policy provided for the WE DELVR LOGISTICS preview site. It
                        should be reviewed by qualified legal counsel before public release.
                    </p>
                </div>
            </main>
            <Footer />
        </div>
    );
}
